export function returnFullName(data: any & { firstName?: string; lastName?: string }) {
  if (data?.firstName && data?.lastName) return `${data.firstName} ${data.lastName}`
  if (data?.firstName) return data.firstName
  return data?.lastName ?? ' '
}
